const queryStringToNumberArray = (q: string, maximum: number): number[] => {
  // 1. convert strings to array
  // 2. test if n is number && less than maximum && is a whole number
  // 3. filter out duplicates (using Set)
  // 4. return an array of numbers
  return Array.from(new Set(q.split(',').map(n => +n).filter(n => !isNaN(n) && n < maximum && n % 1 === 0)))
}

export { queryStringToNumberArray }
